export default __webpack_public_path__ + "static/media/upfrontCosts.a002e3d7.svg";